<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索队伍" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchTeam } from '@/api/ballsports/base/team';


export default {
    name: "team-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchTeam,
        }
    }
}
</script>
